import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { type SelfScheduleCalendarDayData, SelfSchedulingPreference, ShiftType } from "../../../utils/models";

export const SubIcon: FC<{ dayData: SelfScheduleCalendarDayData }> = ({ dayData }) => {
	const { t } = useTranslation();
	let src: string | null = null;
	let alt = "";

	switch (dayData.dayPreference) {
		case SelfSchedulingPreference.PTO:
			src = "/day-off.svg";
			alt = t("pto");
			break;
		case SelfSchedulingPreference.WANT_TO_WORK:
			if (dayData.shiftType === ShiftType.Day) {
				src = "/sun.svg";
				alt = "day";
			} else if (dayData.shiftType === ShiftType.Night) {
				src = "/moon.svg";
				alt = "night";
			}
			break;
	}

	if (!src) return null;

	return <img src={src} alt={alt} style={{ width: "12px", height: "12px", marginTop: "1px" }} />;
};
